var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAddToPouch = function SvgAddToPouch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.005 6.661a2.75 2.75 0 0 0-2.75 2.75v1.24c.855-.21 1.785-.323 2.75-.323.965 0 1.895.113 2.75.323V9.41a2.75 2.75 0 0 0-2.75-2.75Zm0-1.833a4.583 4.583 0 0 0-4.583 4.583v1.895c-.14.07-.277.142-.409.217-1.297.741-2.341 1.905-2.341 3.389v8.25h11.916v-1.834H9.505v-6.416c0-.443.262-.97.917-1.469v.552a.917.917 0 1 0 1.833 0v-1.443a9.493 9.493 0 0 1 2.75-.39c1.012 0 1.947.145 2.75.39v1.443a.917.917 0 1 0 1.834 0v-.551c.654.497.916 1.025.916 1.467v.917h1.834v-.916c0-1.484-1.044-2.648-2.342-3.39a7.405 7.405 0 0 0-.409-.216V9.411a4.583 4.583 0 0 0-4.583-4.583Zm7.333 13.75v-1.833h-1.833v1.833h-1.833v1.834h1.833v1.833h1.834V20.41h1.833v-1.833h-1.834Z",
    fill: "#FFA0CC"
  })));
};

export default SvgAddToPouch;